"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _startCase2 = _interopRequireDefault(require("lodash/startCase"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * SentenceCase takes a String (or a one word string)
 * and changes it to sentence case
 * e.g. 'districtAdmin' => 'District Admin'
 *
 */
var _default = exports["default"] = function _default(settings, callbackHandler) {
  return function (_ref) {
    var value = _ref.value,
      row = _ref.row;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-center"
    }, (0, _startCase2["default"])(value));
  };
};